import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M3 20H21V6H11L9 4H5L3 6V20ZM5 8H12H19V18H5V8Z"
	}), /* @__PURE__ */ _jsx("rect", {
		width: 16,
		x: 3,
		y: 8,
		height: 10
	})]
});
export default SvgFilledFolder;
